const openedPopups = new Set();

const PopupManager = {
  addPopup: popup => {
    openedPopups.add(popup);
  },

  removePopup: popup => {
    openedPopups.delete(popup);
  },

  getOpenedPopupsCount: () => {
    return openedPopups.size;
  },
};

export default PopupManager;
